import { createAsyncThunk } from '@reduxjs/toolkit';
import { IAdminSlice } from '@/redux/slices/admin/types';
import { updateCmsConfigVariable } from '@/lib/api-server/admin/updateCmsConfigVariable';

export const putCmsConfigVariable = createAsyncThunk(
  'admin/putCmsConfigVariable',
  async (
    {
      variable,
      value,
    }: {
      variable: 'robots' | 'sitemap';
      value: string | null;
    },
    { rejectWithValue }
  ) =>
    await updateCmsConfigVariable({
      variable,
      value,
    }).then((r) => {
      if (!r.success) return rejectWithValue(r.error);
      return true;
    })
);

const pending = (state: IAdminSlice) => {
  state.config.loading = true;
};

const rejected = (state: IAdminSlice) => {
  state.config.loading = false;
};

const fulfilled = (
  state: IAdminSlice,
  {
    meta: {
      arg: { variable, value },
    },
  }: {
    meta: { arg: { variable: 'robots' | 'sitemap'; value: string } };
  }
) => {
  state.config = {
    ...state.config,
    [variable]: value,
    loading: false,
  };
};

export default {
  action: putCmsConfigVariable,
  pending,
  rejected,
  fulfilled,
};
